import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Heading, useToast, Center } from '@chakra-ui/react';
import TriviaQuestionForm from './Form';
import useTrivia from './hooks/useTrivia';
import { ROUTES } from '../../consts/routes';

const CreateTriviaQuestion = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const { createTriviaTemplate, createTriviaAssignment, loading } = useTrivia();

  const dateFromParams = searchParams.get('date');

  const handleSubmit = async (data: any) => {
    try {
      // 1. Crear el template
      const templateData = {
        title: data.title,
        text: data.text || '',
        explanation: data.explanation || '',
        points: data.points,
        time_limit_seconds: data.time_limit_seconds || null,
        speed_bonus_enabled: data.speed_bonus_enabled,
        speed_bonus_multiplier: data.speed_bonus_enabled ? data.speed_bonus_multiplier : null,
        extra_data: data.extra_data,
        trivia_template_answers_attributes: data.trivia_answers_attributes.map((answer: any, index: number) => ({
          text: answer.text,
          is_correct: answer.is_correct,
          position: index + 1,
          extra_data: answer.extra_data
        }))
      };

      const template = await createTriviaTemplate({ template: templateData });

      // 2. Si hay fecha, crear la asignación
      if (data.date) {
        await createTriviaAssignment({
          assignment: {
            trivia_question_template_id: template.uid,
            date: data.date,
            position: data.position || undefined,
            active: data.active
          }
        });
      }

      toast({
        title: 'Template creado',
        description: data.date
          ? 'El template se ha creado y asignado a la fecha correctamente'
          : 'El template se ha creado. Puedes asignarlo a fechas desde el calendario.',
        status: 'success',
        duration: 4000,
        isClosable: true
      });
      navigate(ROUTES.TRIVIA.all);
    } catch (error: any) {
      toast({
        title: 'Error al crear',
        description: error?.response?.data?.error || error?.message || 'No se pudo crear el template',
        status: 'error',
        duration: 5000,
        isClosable: true
      });
    }
  };

  const handleCancel = () => {
    navigate(ROUTES.TRIVIA.all);
  };

  // Create initial data with date from URL params if available
  const initialData = dateFromParams ? { date: dateFromParams } as any : undefined;

  return (
    <Center w="full" pb={4}>
      <Box color="white" w="full" px={4}>
        <Heading textAlign="center" mb={6} as="h1">
          Crear Template de Trivia
        </Heading>

        <TriviaQuestionForm
          initialData={initialData}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          loading={loading}
          isEdit={false}
        />
      </Box>
    </Center>
  );
};

export default CreateTriviaQuestion;
